<template>
  <div>
    <CampanhaForm
      :isEdit="false"
      :item="currentItem"
      :create="createItem"
      :close="closeCreate"
      :descSingular="descSingular"
      :dimensoes="dimensoes"
      :operadores="operadores"
      :representantes="representantes"
      :produtos="produtos"
      :loadProdutos="loadProdutos"
      :initialItem="initialItem"
      :initialDimensaoForm="initialDimensaoForm"
      :initialDimensao="initialDimensao"
      :initialMetaOperador="initialMetaOperador"
    />
    <CampanhaForm
      :isEdit="true"
      :item="currentItem"
      :update="updateItem"
      :close="closeEdit"
      :descSingular="descSingular"
      :dimensoes="dimensoes"
      :operadores="operadores"
      :representantes="representantes"
      :produtos="produtos"
      :loadProdutos="loadProdutos"
      :initialItem="initialItem"
      :initialDimensaoForm="initialDimensaoForm"
      :initialDimensao="initialDimensao"
      :initialMetaOperador="initialMetaOperador"
    />
    <CTabs variant="tabs" class="nav-tabs-boxed">
      <CTab title="Objetivos Operadores">
        <!-- Filtros Avançados -->
        <CCard class="mb-3">
          <CCardHeader class="filter-header">
            <fa-icon icon="filter" class="mr-2" />
            <strong>Filtros de Pesquisa</strong>
            <CButton
              v-if="temFiltrosAtivos"
              color="link"
              size="sm"
              @click="limpaFiltros"
              class="ml-auto text-white"
            >
              <fa-icon icon="times-circle" class="mr-1" />
              Limpar Todos
            </CButton>
          </CCardHeader>
          <CCardBody>
            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <label class="filter-label">
                    <fa-icon icon="search" class="mr-1" />
                    Buscar por Nome
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="filtros.nome"
                    placeholder="Digite o nome da campanha"
                    @input="aplicarFiltros"
                  />
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label class="filter-label">
                    <fa-icon icon="calendar" class="mr-1" />
                    Data
                  </label>
                  <div class="input-group">
                    <datetime
                      input-class="form-control"
                      v-model="filtros.data"
                      type="date"
                      v-on:input="loadCampanhasPorData"
                      placeholder="dd/mm/aaaa"
                      :phrases="{ ok: 'Confirmar', cancel: 'Fechar' }"
                      value-zone="local"
                      :format="'dd/MM/yyyy'"
                      :auto="false"
                    />
                    <CButton
                      v-if="filtros.data"
                      color="secondary"
                      size="sm"
                      @click="limparFiltroData"
                      class="input-group-addon-right"
                      v-c-tooltip="'Limpar data'"
                    >
                      <fa-icon icon="times" />
                    </CButton>
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label class="filter-label">
                    <fa-icon icon="info-circle" class="mr-1" />
                    Status
                  </label>
                  <select class="form-control" v-model="filtros.status" @change="aplicarFiltros">
                    <option value="">Todos</option>
                    <option value="Não apurada">Não apurada</option>
                    <option value="Apurada">Apurada</option>
                    <option value="Fechada">Fechada</option>
                  </select>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label class="filter-label">
                    <fa-icon icon="list" class="mr-1" />
                    Tipo Campanha
                  </label>
                  <select class="form-control" v-model="filtros.tipoCampanha" @change="aplicarFiltros">
                    <option value="">Todos</option>
                    <option value="D">Dimensão</option>
                    <option value="M">Mix</option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label class="filter-label">
                    <fa-icon icon="file-invoice" class="mr-1" />
                    Tipo Apuração
                  </label>
                  <select class="form-control" v-model="filtros.tipoApuracao" @change="aplicarFiltros">
                    <option value="">Todos</option>
                    <option value="P">Pedido</option>
                    <option value="N">Nota Fiscal</option>
                  </select>
                </div>
              </div>
            </div>
          </CCardBody>
        </CCard>

        <!-- Header com botão de nova campanha -->
        <div class="row mb-3">
          <div class="col-md-12 text-right">
            <CButton color="primary" @click="openCreate" size="sm">
              <fa-icon icon="plus" class="mr-1" />
              Nova Campanha de Meta
            </CButton>
          </div>
        </div>
        <!-- Empty State -->
        <div v-if="itemsFiltrados.length === 0" class="empty-state">
          <div class="empty-state-icon">
            <fa-icon :icon="temFiltrosAtivos ? 'filter' : 'calendar-times'" size="4x" />
          </div>
          <h4 class="empty-state-title">
            {{ temFiltrosAtivos ? 'Nenhuma campanha encontrada' : 'Nenhuma campanha de metas cadastrada' }}
          </h4>
          <p class="empty-state-description">
            {{ temFiltrosAtivos
              ? 'Não há campanhas que correspondam aos filtros aplicados. Tente ajustar os critérios de busca.'
              : 'Comece criando sua primeira campanha de metas para gerenciar objetivos dos operadores e representantes.'
            }}
          </p>
          <CButton
            v-if="!temFiltrosAtivos"
            color="primary"
            size="lg"
            @click="openCreate"
            class="mt-3"
          >
            <fa-icon icon="plus" class="mr-2" />
            Criar Primeira Campanha
          </CButton>
          <CButton
            v-else
            color="secondary"
            size="lg"
            @click="limpaFiltros"
            class="mt-3"
          >
            <fa-icon icon="times" class="mr-2" />
            Limpar Filtros
          </CButton>
        </div>

        <!-- Table with Data -->
        <div v-else class="table-responsive">
          <div class="table-info mb-2">
            <small class="text-muted">
              <fa-icon icon="list" class="mr-1" />
              Exibindo {{ itemsFiltrados.length }} de {{ items.length }} campanha(s)
            </small>
          </div>
          <table class="table table-hover">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Data Inicial</th>
                <th>Data Final</th>
                <th>Tipo</th>
                <th>Público</th>
                <th>Status</th>
                <th class="text-center">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in itemsFiltrados" :key="item.id">
                <td class="highlight">
                  <strong>{{ item.nome }}</strong>
                </td>
                <td>
                  <fa-icon icon="calendar" class="text-muted mr-1" />
                  {{ moment(item.dataInicio).format('DD/MM/YYYY HH:mm') }}
                </td>
                <td>
                  <fa-icon icon="calendar-check" class="text-muted mr-1" />
                  {{ moment(item.dataFim).format('DD/MM/YYYY HH:mm') }}
                </td>
                <td>
                  <CBadge :color="item.tipoCampanha === 'D' ? 'info' : 'warning'">
                    <fa-icon :icon="item.tipoCampanha === 'D' ? 'layer-group' : 'box'" class="mr-1" />
                    {{ item.tipoCampanha === 'D' ? 'Dimensão' : 'Mix' }}
                  </CBadge>
                </td>
                <td>
                  <CBadge v-if="item.metasOperadores.length" color="secondary" class="mr-1">
                    <fa-icon icon="headset" class="mr-1" />
                    {{ item.metasOperadores.length }} operador(es)
                  </CBadge>
                  <CBadge v-if="item.metasRepresentantes.length" color="secondary">
                    <fa-icon icon="user-tie" class="mr-1" />
                    {{ item.metasRepresentantes.length }} representante(s)
                  </CBadge>
                </td>
                <td>
                  <CBadge
                    :color="getStatusColor(item.status)"
                    class="status-badge"
                  >
                    <fa-icon :icon="getStatusIcon(item.status)" class="mr-1" />
                    {{ item.status }}
                  </CBadge>
                </td>
                <td class="actions text-center">
                  <CButton
                    color="primary"
                    size="sm"
                    @click="openEdit(item)"
                    v-c-tooltip="'Editar campanha'"
                    class="mr-1"
                  >
                    <fa-icon icon="pencil-alt" />
                  </CButton>
                  <CButton
                    color="info"
                    size="sm"
                    @click="duplicarConfirm(item)"
                    v-c-tooltip="'Duplicar campanha'"
                    class="mr-1"
                  >
                    <fa-icon icon="copy" />
                  </CButton>
                  <CButton
                    color="danger"
                    size="sm"
                    @click="deleteConfirm(item.id)"
                    v-c-tooltip="'Excluir campanha'"
                  >
                    <fa-icon icon="trash-alt" />
                  </CButton>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </CTab>
    </CTabs>
  </div>
</template>
<script>
import clone from 'just-clone';
import { get, post, put, del, isSessaoExpirada } from '@/helpers/apiRequest';
import { toDateTime } from '@/helpers/utils';
import _map from 'lodash/map';
import moment from 'moment';
import CampanhaForm from './CampanhaMetas.vue';
import {
  defaultCampanhaMetasItem,
  normalizaPublicoMeta,
  possuiPublicoMeta,
  representantesForaDosElegiveis,
  representantesValidos,
} from '../../../../helpers/campanhas';

export default {
  name: 'objetivos-operadores',
  components: {
    CampanhaForm,
  },
  data() {
    return {
      descPlural: '',
      descSingular: '',
      loading: false,
      items: [],
      itemsFiltrados: [],
      dimensoes: [],
      operadores: [],
      representantes: [],
      produtos: [],
      filtros: {
        data: '',
        nome: '',
        status: '',
        tipoCampanha: '',
        tipoApuracao: '',
      },
      currentItem: defaultCampanhaMetasItem(),
      currentAccess: false,
    };
  },
  computed: {
    temFiltrosAtivos() {
      return (
        this.filtros.data ||
        this.filtros.nome ||
        this.filtros.status ||
        this.filtros.tipoCampanha ||
        this.filtros.tipoApuracao
      );
    },
  },
  methods: {
    initialItem(){
      return {
        nome: "",
        dataInicio: moment().format(),
        dataFim: moment().add(1, "days").format(),
        metasOperadores: [],
        metasRepresentantes: [],
        tipoCampanha: "D",
        tipoApuracao: "P",
        dimensoes: [],
        mix: [],
      }
    },
    initialDimensaoForm() {
      return {indice: -1}
    },

    initialDimensao() {
      return {
        coluna: "",
        dimensao: ""
      }
    },
    initialMetaOperador(){
      return {
        codOp: "",
        vlMeta: "1",
        positivacao: "1",
        percMix: "1",
      }
    },
    loadDescricaoModulo() {
      const { modulos } = JSON.parse(localStorage.getItem('app'));
      const { descPlural, descSingular } = modulos.find(
        (m) => m.nome === 'ADMIN_CAMPANHA'
      );
      this.descPlural = descPlural;
      this.descSingular = descSingular;
    },
    loadCampanhas() {
      this.loading = true;
      get('/admin/campanhas')
        .then((json) => {
          this.items = this.midllewareCampanhas(json);
          this.itemsFiltrados = this.items;
          this.loading = false;
          this.aplicarFiltros();
        })
        .catch(() => (this.loading = false));
    },
    loadCampanhasPorData(data) {
      if (data) {
        this.aplicarFiltros();
      } else {
        this.loadCampanhas();
      }
      return false;
    },
    aplicarFiltros() {
      let campanhasFiltradas = [...this.items];

      // Filtro por data
      if (this.filtros.data) {
        const dataFiltro = moment(this.filtros.data).format('YYYY-MM-DD');
        campanhasFiltradas = campanhasFiltradas.filter((campanha) => {
          const dataInicio = moment(campanha.dataInicio).format('YYYY-MM-DD');
          const dataFim = moment(campanha.dataFim).format('YYYY-MM-DD');
          return dataFiltro >= dataInicio && dataFiltro <= dataFim;
        });
      }

      // Filtro por nome
      if (this.filtros.nome) {
        const nomeBusca = this.filtros.nome.toLowerCase();
        campanhasFiltradas = campanhasFiltradas.filter((campanha) =>
          campanha.nome.toLowerCase().includes(nomeBusca)
        );
      }

      // Filtro por status
      if (this.filtros.status) {
        campanhasFiltradas = campanhasFiltradas.filter(
          (campanha) => campanha.status === this.filtros.status
        );
      }

      // Filtro por tipo de campanha
      if (this.filtros.tipoCampanha) {
        campanhasFiltradas = campanhasFiltradas.filter(
          (campanha) => campanha.tipoCampanha === this.filtros.tipoCampanha
        );
      }

      // Filtro por tipo de apuração
      if (this.filtros.tipoApuracao) {
        campanhasFiltradas = campanhasFiltradas.filter(
          (campanha) => campanha.tipoApuracao === this.filtros.tipoApuracao
        );
      }

      this.itemsFiltrados = campanhasFiltradas;
    },
    limpaFiltros() {
      this.filtros = {
        data: '',
        nome: '',
        status: '',
        tipoCampanha: '',
        tipoApuracao: '',
      };
      this.loadCampanhas();
    },
    limparFiltroData() {
      this.filtros.data = '';
      this.loadCampanhas();
    },
    getStatusColor(status) {
      const statusMap = {
        'Não apurada': 'secondary',
        'Apurada': 'success',
        'Fechada': 'dark'
      };
      return statusMap[status] || 'secondary';
    },
    getStatusIcon(status) {
      const iconMap = {
        'Não apurada': 'clock',
        'Apurada': 'check-circle',
        'Fechada': 'lock'
      };
      return iconMap[status] || 'info-circle';
    },
    midllewareCampanhas(campanhas) {
      return _map(campanhas, (i) => {
        return {
          ...normalizaPublicoMeta(i),

          dataInicio: moment(i.dataInicio).format(),
          dataFim: moment(i.dataFim).format(),
        };
      });
    },
    loadDimensoes() {
      this.loading = true;
      get('/admin/campanhas-dimensoes')
        .then((json) => {
          this.dimensoes = json;
          this.loading = false;
        })
        .catch(() => (this.loading = false));
    },
    loadOperadores() {
      this.loading = true;
      get('/admin/campanhas-operadores')
        .then((json) => {
          this.operadores = json;
          this.loading = false;
        })
        .catch(() => (this.loading = false));
    },
    loadRepresentantes() {
      get('/admin/campanhas-representantes')
        .then((json) => {
          this.representantes = json;
        })
        .catch((err) => {
          if (isSessaoExpirada(err)) return;

          this.$swal({
            title: 'Falha ao carregar representantes',
            text: 'Não foi possível carregar a lista de representantes. Recarregue a página para cadastrar metas por representante.',
            icon: 'warning',
            showConfirmButton: true,
          });
        });
    },
    loadProdutos(termo = '', take = 32) {
      this.loading = true;

      get(`/admin/campanhas-produtos-paginados?termo=${termo}&take=${take}`)
        .then((json) => {
          this.produtos = json.itens;
          this.loading = false;
        })
        .catch(() => (this.loading = false));
    },
    resetCampanhaForm(){
      this.initialItem();
      this.initialDimensaoForm();
      this.initialDimensao();
      this.initialMetaOperador();
      this.currentItem = defaultCampanhaMetasItem();
    },
    openCreate() {
      this.resetCampanhaForm();
      this.$modal.show('campanhaCreate');
    },
    closeCreate() {
      this.resetCampanhaForm();
      this.$modal.hide('campanhaCreate');
    },
    createItem(item) {
      this.loading = true;
      post('/admin/campanhas', item).then((json) => {
        this.loadCampanhas();
        this.loading = false;
        this.closeCreate();
        this.$swal({
          title: 'Sucesso!',
          text: json.message,
          showCancelButton: false,
          cancelButtonText: 'Fechar',
          showConfirmButton: true,
          icon: 'success',
        });
      }).catch((err) => {
        this.$swal({
          title: 'Falha ao cadastrar!',
          text: err.message,
          showCancelButton: false,
          cancelButtonText: 'Fechar',
          showConfirmButton: false,
          icon: 'error',
        });
      });
    },
    openEdit(item) {
      this.currentItem = clone(item);
      this.$modal.show('campanhaEdit');
    },
    closeEdit() {
      this.resetCampanhaForm();
      this.$modal.hide('campanhaEdit');
    },
    updateItem() {
      this.loading = true;
      const { id } = this.currentItem;

      put(`/admin/campanhas/${id}`, this.currentItem)
        .then((json) => {
          this.loading = false;
          this.loadCampanhas();
          this.closeEdit();
          this.$swal({
            title: 'Sucesso!',
            text: json.message,
            showCancelButton: false,
            cancelButtonText: 'Fechar',
            showConfirmButton: true,
            icon: 'success',
          });
        })
        .catch((err) => {
          this.loading = false;
          this.$swal({
            title: 'Falha ao atualizar!',
            text: err.message,
            showCancelButton: false,
            cancelButtonText: 'Fechar',
            showConfirmButton: true,
            icon: 'error',
          });
        });
    },
    duplicarConfirm(item) {
      this.$swal({
        title: 'Duplicar Campanha?',
        text: `Deseja criar uma cópia da campanha "${item.nome}"?`,
        showCancelButton: true,
        icon: 'question',
        confirmButtonText: 'Duplicar',
        cancelButtonText: 'Cancelar',
        input: 'text',
        inputLabel: 'Nome da nova campanha',
        inputValue: `${item.nome} - Cópia`,
        inputValidator: (value) => {
          if (!value) {
            return 'Você precisa informar um nome para a campanha!';
          }
        },
      })
        .then((res) => {
          if (res.value) {
            this.duplicateCampanha(item, res.value);
          }
        })
        .catch(() => { });
    },
    duplicateCampanha(item, novoNome) {
      const novaCampanha = {
        ...clone(item),
        id: undefined,
        nome: novoNome,
        status: 'Não apurada',
        dataInicio: moment().format(),
        dataFim: moment().add(1, 'days').format(),
      };

      // A copia nasce sem apuracao: representante inativo sai sem perda de
      // realizado, mas a API recusaria o POST inteiro se ele fosse junto.
      const removidos = representantesForaDosElegiveis(
        novaCampanha.metasRepresentantes,
        this.representantes
      );
      novaCampanha.metasRepresentantes = representantesValidos(
        novaCampanha.metasRepresentantes,
        this.representantes
      );

      if (!possuiPublicoMeta(novaCampanha)) {
        this.$swal({
          title: 'Falha ao duplicar!',
          text: 'Os representantes desta campanha não estão mais ativos e ela não tem operadores, então a cópia ficaria sem público.',
          showConfirmButton: true,
          icon: 'error',
        });
        return Promise.resolve();
      }

      this.loading = true;

      return post('/admin/campanhas', novaCampanha)
        .then((json) => {
          this.loadCampanhas();
          this.loading = false;
          this.$swal({
            title: 'Sucesso!',
            text: removidos.length
              ? `Campanha duplicada com sucesso. ${removidos.length} representante(s) inativo(s) ficaram de fora da cópia.`
              : 'Campanha duplicada com sucesso',
            showCancelButton: false,
            cancelButtonText: 'Fechar',
            showConfirmButton: true,
            icon: 'success',
          });
        })
        .catch((err) => {
          this.loading = false;
          this.$swal({
            title: 'Falha ao duplicar!',
            text: err.message,
            showCancelButton: false,
            cancelButtonText: 'Fechar',
            showConfirmButton: true,
            icon: 'error',
          });
        });
    },
    deleteConfirm(id) {
      this.$swal({
        title: 'Confirma Remover?',
        text: 'Essa ação não poderá ser desfeita',
        showCancelButton: true,
        icon: 'warning',
        confirmButtonText: 'Excluir',
        cancelButtonText: 'Cancelar',
      })
        .then((res) => {
          if (res.value) {
            this.loading = true;
            del(`/admin/campanhas/${id}`)
              .then((json) => {
                this.loading = false;
                this.loadCampanhas();
              })
              .catch((err) => {
                this.loading = false;
                this.$swal({
                  title: 'Falha ao remover',
                  icon: 'error',
                });
              });
          }
        })
        .catch(() => { });
    },
    toDateTime,
    moment,
  },
  beforeMount() {
    this.loadDimensoes();
    this.loadOperadores();
    this.loadRepresentantes();
    this.loadProdutos();
    this.loadCampanhas();
    this.loadDescricaoModulo();
  },
};
</script>

<style scoped>
/* Filter Header */
.filter-header {
  background: linear-gradient(135deg, #3a3e81 0%, #2298a3 100%);
  color: white;
  font-weight: 600;
  padding: 0.75rem 1.25rem;
  display: flex;
  align-items: center;
}

.filter-header .ml-auto {
  margin-left: auto;
}

/* Header Buttons */
.header-buttons {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  padding-bottom: 1rem;
}

.header-buttons button {
  margin-left: 5px;
}

/* Filter Label */
.filter-label {
  font-size: 12px;
  font-weight: 500;
  color: #344054;
  margin-bottom: 3px;
}

/* Table Info */
.table-info {
  text-align: right;
  padding: 0.5rem 0;
}

/* Input Group Addon */
.input-group {
  position: relative;
}

.input-group .input-group-addon-right {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  z-index: 10;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.input-group .vdatetime input {
  padding-right: 40px;
}

/* Table Improvements */
.table tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.02);
}

.table td {
  vertical-align: middle;
}

.table td.highlight strong {
  color: #3a3e81;
}

/* Badge Styling */
.status-badge {
  font-weight: 600;
  padding: 0.375rem 0.75rem;
  font-size: 0.8125rem;
  display: inline-flex;
  align-items: center;
}

/* Actions Column */
.actions {
  white-space: nowrap;
}

.actions .btn {
  margin: 0 2px;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 4rem 2rem;
  background: linear-gradient(135deg, rgba(58, 62, 129, 0.03) 0%, rgba(34, 152, 163, 0.03) 100%);
  border-radius: 0.5rem;
  margin-top: 2rem;
  animation: fadeIn 0.5s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.empty-state-icon {
  color: #cbd5e0;
  margin-bottom: 1.5rem;
}

.empty-state-title {
  color: #2d3748;
  font-weight: 600;
  font-size: 1.5rem;
  margin-bottom: 0.75rem;
}

.empty-state-description {
  color: #718096;
  font-size: 1rem;
  max-width: 500px;
  margin: 0 auto 1rem;
  line-height: 1.6;
}

/* Utility Classes */
.mr-1 {
  margin-right: 0.25rem;
}

.mr-2 {
  margin-right: 0.5rem;
}

.ml-2 {
  margin-left: 0.5rem;
}

.mt-3 {
  margin-top: 1rem;
}

/* Responsive */
@media (max-width: 768px) {
  .header-buttons {
    justify-content: flex-start;
    margin-top: 1rem;
  }

  .table {
    font-size: 0.875rem;
  }

  .table td.highlight strong {
    font-size: 0.875rem;
  }
}
</style>
